export default {
  "nav.home": "Strona główna",
  "nav.spreadsheet": "Arkusz",
  "nav.articles": "Poradniki",
  "nav.categories": "Kategorie",
  "nav.shoppingGuide": "Przewodnik zakupowy",

  "hero.seoTitle": "usfans Spreadsheet — Znajdź produkty i oszczędzaj | usfanssheet.today",
  "hero.eyebrow": "ZASOBY ARKUSZA USFANS",
  "hero.title": "usfans Spreadsheet — Znajdź produkty, porównaj opcje i kupuj mądrzej",
  "hero.subtitle": "Przeglądaj uporządkowane znaleziska arkusza usfans, poradniki zakupowe i praktyczne wskazówki oszczędzania w jednym miejscu.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "kup teraz",
  "hero.trust": "Znaleziska produktów • Wskazówki oszczędzania • Przewodniki kategorii • Porady zakupowe",

  "value.title": "Wszystko, czego potrzebujesz, aby kupować mądrzej w jednym miejscu",
  "value.subtitle": "Nasze zasoby arkusza usfans pomagają szybciej przeglądać produkty, rozumieć kategorie i podejmować lepsze decyzje zakupowe.",
  "value.card1.title": "Arkusz usfans",
  "value.card1.desc": "Znajdź uporządkowane odkrycia produktów i przydatne informacje w różnych kategoriach.",
  "value.card2.title": "Wskazówki oszczędzania",
  "value.card2.desc": "Poznaj praktyczne sposoby porównywania opcji i oszczędzania budżetu zakupowego.",
  "value.card3.title": "Przewodniki kategorii",
  "value.card3.desc": "Zrozum buty, bluzy, koszulki, kurtki, torby i więcej, zanim kupisz.",
  "value.card4.title": "Porady zakupowe",
  "value.card4.desc": "Postępuj zgodnie z prostymi instrukcjami krok po kroku, aby z pewnością wybierać produkty.",
  "value.card5.title": "Nowe znaleziska",
  "value.card5.desc": "Bądź na bieżąco ze świeżymi pomysłami na produkty i popularnymi wyborami.",
  "value.card6.title": "Przyjazne dla początkujących",
  "value.card6.desc": "Łatwe do zrozumienia wyjaśnienia dla osób, które pierwszy raz korzystają z arkusza.",

  "spreadsheet.title": "Przeglądaj lepsze produkty dzięki arkuszowi usfans",
  "spreadsheet.copy": "Przeszukiwanie tysięcy produktów może być czasochłonne. Nasze zasoby arkusza usfans porządkują przydatne znaleziska produktów w łatwe do przeglądania kategorie, dzięki czemu szybciej znajdziesz to, czego potrzebujesz i podejmiesz lepsze decyzje przed zakupem.",
  "spreadsheet.cta": "Przeglądaj arkusz usfans",

  "how.title": "Jak to działa",
  "how.subtitle": "Prosta ścieżka od przeglądania do pewnego zakupu.",
  "how.step1": "Wybierz kategorię",
  "how.step2": "Przeglądaj znaleziska produktów",
  "how.step3": "Sprawdź szczegóły produktu",
  "how.step4": "Porównaj opcje",
  "how.step5": "Zastosuj wskazówki oszczędzania",
  "how.step6": "Przejdź na główną stronę",

  "popular.title": "Popularne wyszukiwania",
  "popular.subtitle": "Tematy, które użytkownicy najczęściej sprawdzają podczas badania arkusza usfans.",
  "popular.1": "usfans spreadsheet",
  "popular.2": "znaleziska usfans spreadsheet",
  "popular.3": "wskazówki zakupowe usfans",
  "popular.4": "oszczędzanie z usfans",
  "popular.5": "kategorie usfans",
  "popular.6": "przewodnik usfans",
  "popular.7": "najlepsze znaleziska usfans",
  "popular.8": "kupon usfans",
  "popular.9": "kod rabatowy usfans",

  "categories.title": "Przeglądaj kategorie",
  "categories.subtitle": "Przejdź od razu do produktów, które Cię interesują, na głównej stronie.",
  "categories.dropdownLabel": "Wybierz kategorię",

  "safety.title": "Zbadaj, zanim kupisz",
  "safety.copy": "Dobry arkusz powinien pomagać w badaniu, a nie naciskać na zakup. Porównaj produkty, sprawdź szczegóły i poznaj swoje opcje, zanim podejmiesz decyzję.",
  "safety.cta": "Przeglądaj kategorie",

  "articles.title": "Przewodniki arkusza usfans",
  "articles.subtitle": "Oryginalne, szczegółowe artykuły, które pomogą Ci mądrzej kupować i oszczędzać.",

  "final.title": "Gotowy, aby odkryć arkusz usfans?",
  "final.copy": "Zacznij od naszych przewodników, porównaj opcje i przejdź na główną stronę, gdy będziesz gotowy.",
  "final.cta": "Odkryj arkusz usfans",

  "footer.tagline": "Niezależne źródło znalezisk, przewodników i wskazówek zakupowych arkusza usfans.",
  "footer.disclaimer": "usfanssheet.today to niezależne źródło informacji. Zawsze weryfikuj linki docelowe i aktualne oferty na głównej stronie przed zakupem.",
  "footer.mainSite": "Główna strona",
  "footer.allRights": "Wszelkie prawa zastrzeżone.",

  "article.backHome": "Wróć na stronę główną",
  "article.related": "Powiązane artykuły",
  "article.updated": "Zaktualizowano",

  "notFound.title": "Strona nie znaleziona",
  "notFound.subtitle": "Strona, której szukasz, nie istnieje lub została przeniesiona.",
  "notFound.backHome": "Wróć na stronę główną",

  "categories.shoes": "Buty",
  "categories.hoodies": "Bluzy / Swetry",
  "categories.tshirts": "Koszulki",
  "categories.jackets": "Kurtki",
  "categories.pants": "Spodnie / Szorty",
  "categories.headwear": "Nakrycia głowy",
  "categories.sets": "Zestawy",
  "categories.underwear": "Bielizna",
  "categories.jersey": "Koszulka sportowa",
  "categories.accessories": "Akcesoria",
  "categories.bags": "Torby",
  "categories.belts": "Paski",
  "categories.perfumes": "Perfumy",
  "categories.other": "Inne rzeczy",
};